import posthog from 'posthog-js';
import { POSTHOG_SESSION_ID_HEADER } from '@erp/shared-utils';

export function getPosthogSessionId(): string | undefined {
  try {
    const sessionId = posthog.get_session_id();
    if (typeof sessionId !== 'string') {
      return undefined;
    }
    const trimmed = sessionId.trim();
    return trimmed.length ? trimmed : undefined;
  } catch {
    return undefined;
  }
}

/**
 * Deep link to the PostHog session replay for the current session, anchored to
 * the current timestamp so it opens at the moment of the event. Returns
 * undefined when replay is unavailable (e.g. recording disabled or not yet
 * initialized). Used to link Sentry errors back to the replay.
 */
export function getPosthogReplayUrl(): string | undefined {
  try {
    const url = posthog.get_session_replay_url({ withTimestamp: true });
    if (typeof url !== 'string') {
      return undefined;
    }
    const trimmed = url.trim();
    return trimmed.length ? trimmed : undefined;
  } catch {
    return undefined;
  }
}

export function buildPosthogHeaders(existing?: HeadersInit): Headers {
  const headers = new Headers(existing);
  const sessionId = getPosthogSessionId();
  if (sessionId) {
    headers.set(POSTHOG_SESSION_ID_HEADER, sessionId);
  }
  return headers;
}
